import { Button } from 'components/Elements';
import { Form, InputFieldWithInfo, ReactNumberFormatInputField2 } from 'components/Form';
import { useCreateAsset } from 'features/assets/api/createAsset';
import { landValuationSchema } from 'features/assets/schemas';
import React from 'react';
import { dataURItoBlob } from 'utils/dataURIToBlob';

export const RealEstateValuationForm = ({ onSuccess, onBack, selectedImages }) => {
  const createAssetMutation = useCreateAsset();

  return (
    <Form
      id="create-post"
      onSubmit={async (values) => {
        const realEstateAssetData = JSON.parse(localStorage.getItem('realEstateAssetData'));

        const category = localStorage.getItem('assetCategory');

        const bodyFormData = new FormData();
        bodyFormData.append('title', realEstateAssetData.title);
        bodyFormData.append('category', category);
        bodyFormData.append('land_location', realEstateAssetData.land_location);
        bodyFormData.append('coordinates', realEstateAssetData.coordinates);
        bodyFormData.append('product', realEstateAssetData.product);
        bodyFormData.append('type_of_title', realEstateAssetData.type_of_title);
        bodyFormData.append('size_of_land', realEstateAssetData.size_of_land);
        bodyFormData.append('whats_on_land', realEstateAssetData.whats_on_land);
        bodyFormData.append('specify_others', realEstateAssetData.specify_others);
        bodyFormData.append('description', realEstateAssetData.description);
        bodyFormData.append('purchase_amount', values.purchase_amount);
        bodyFormData.append('current_worth', values.current_worth);
        bodyFormData.append('purchase_date', values.purchase_date);
        // console.log('land submit', values)
        if (selectedImages) {
          selectedImages.forEach((image, index) => {
            if (image) {
              bodyFormData.append(`pictures`, dataURItoBlob(image));
            }
          });
        }

        await createAssetMutation.mutateAsync({ data: bodyFormData }).then(async (data) => {
          localStorage.removeItem('assetCategory');
          localStorage.removeItem('formStep');
          localStorage.removeItem('realestateAssetDetail');
          localStorage.removeItem('realestateImageDetail');
          localStorage.removeItem('assetCategory');
          localStorage.removeItem('pictureAssetData');

          onSuccess();
        });
      }}
      schema={landValuationSchema}
    >
      {({ register, formState, watch, setValue }) => (
        <div className="bg-white rounded-2xl shadow p-6 mb-4 w-full">
          <div className="mb-4">Valuation</div>
          <div className="mb-2">
            To enhance your prospects of securing a loan, it's imperative to furnish precise and
            comprehensive information.
          </div>
          <div className="md:mx-48">
            <div className="">
              <div className="flex flex-row items-center justify-between mt-3">
                <div className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  How much did you buy it at? (UGX)
                </div>
              </div>
              <ReactNumberFormatInputField2
                prefix="UGX "
                name="purchase_amount"
                // value={amount}
                error={formState.errors['purchase_amount']}
                registration={register('purchase_amount')}
                onChange={(event) => {
                  //console.log('amount', event);
                  formState.errors['purchase_amount'] = '';
                  setValue('purchase_amount', event.floatValue);
                }}
              />
            </div>
            <div className="mb-2">
              <div className="flex flex-row items-center justify-between mt-3">
                <div className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  How much is it worth currently? (UGX)
                </div>
              </div>
              <ReactNumberFormatInputField2
                prefix="UGX "
                name="current_worth"
                // value={amount}
                error={formState.errors['current_worth']}
                registration={register('current_worth')}
                onChange={(event) => {
                  console.log('amount', event);
                  formState.errors['current_worth'] = '';
                  setValue('current_worth', event.floatValue);
                }}
              />
            </div>
            <InputFieldWithInfo
              type="date"
              label="When did you buy it?"
              error={formState.errors['purchase_date']}
              registration={register('purchase_date')}
              onChange={(event) => {
                //console.log('amount', event);
                formState.errors['purchase_date'] = '';
                setValue('purchase_date', event.target.value);
              }}
            />
          </div>
          <div className="flex flex-row space-x-2 justify-end mt-4">
            <Button
              variant="outline"
              onClick={() => {
                onBack();
              }}
            >
              Back
            </Button>
            <Button isLoading={createAssetMutation.isLoading} type="submit">
              Finish
            </Button>
          </div>
        </div>
      )}
    </Form>
  );
};
